<template>
  <el-dialog
    width="30%"
    :title="action == 'edit' ? '编辑路由' : '添加路由'"
    :visible="show"
    @close="closeDialog"
    @open="init"
    :close-on-click-modal="false"
  >
    <el-form :model="form2" :rules="rules" ref="form2">
      <el-form-item label="商户名称" :label-width="formLabelWidth" prop="appId">
        <el-select
          v-model="form2.appId"
          filterable
          placeholder="请选择商户"
          :disabled="isDisabled"
        >
          <el-option key="0" label="--请选择--" value="0"></el-option>
          <el-option
            v-for="merchant in merchantList"
            :label="merchant.value + '-' + merchant.name"
            :key="merchant.value"
            :value="merchant.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="强制路由"
        prop="routeStatus"
        :label-width="formLabelWidth"
        v-if="$store.state.roleId == '1070960390067716097'"
      >
        <el-select v-model="form2.routeStatus" placeholder="请选择路由状态" 
        :disabled="$store.state.roleId == '2125410685723869666'">
          <el-option key="" label="--请选择--" value=""></el-option>
          <el-option label="开通" value="01"></el-option>
          <el-option label="关闭" value="00"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="代收渠道"
        prop="channelId"
        :label-width="formLabelWidth"
        v-if="form2.routeStatus == '01' && $store.state.roleId == '1070960390067716097'"
      >
        <el-select
          v-model="form2.channelId"
          filterable
          placeholder="请选择代收渠道"
          :disabled="$store.state.roleId == '2125410685723869666'"
        >
          <el-option
            v-for="item in collectionOption"
            :key="item.channelId"
            :label="item.channelName"
            :value="item.channelId"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item
        label="代付渠道"
        prop="withdrawChannelId"
        :label-width="formLabelWidth"
        v-if="form2.routeStatus == '01' && $store.state.roleId == '1070960390067716097'"
      >
        <el-select
          v-model="form2.withdrawChannelId"
          filterable
          placeholder="请选择代付渠道"
          :disabled="$store.state.roleId == '2125410685723869666'"
        >
          <el-option
            v-for="item in paymentOption"
            :key="item.channelId"
            :label="item.channelName"
            :value="item.channelId"
          ></el-option>
        </el-select>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="saveSystem" v-if="isButton"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import ElRow from 'element-ui/packages/row/src/row'
import ElCol from 'element-ui/packages/col/src/col'
import { isNumber } from '../../utils/validate'

export default {
  components: {
    ElCol,
    ElRow,
  },
  name: 'SystemEdit',
  props: {
    show: Boolean,
    value: Object,
    action: String,
  },
  data() {
    return {
      dialogShow: this.show,
      groups: '',
      isButton: true,
      isDisabled: false,
      time: { start: '00:00', step: '00:01', end: '23:59' },
      isEdit: false,
      form2: {
        productId: '',
        agtId: '',
        channelId: '',
        routeStatus: '00',
        deductionType: '',
        productPrice: '',
        routeWeight: '',
        timeStart: '',
        timeEnd: '',
        appId: '',
        rate: '5',
        fee: '5',
        withdrawChannelId: '',
        editPageVer: 'v2',
      },
      merchantList: [],
      channelInfoList: [],
      channelInfoListByProduct: [],
      productList: [],
      agtList: [],
      channelList: [],
      formLabelWidth: '120px',
      fromData: {},
      rules: {
        appId: [{ required: true, message: '请选择商户', trigger: 'change' }],
        channelId: [{ required: true, message: '请选择支付渠道' }],
        withdrawChannelId: [
          {
            required: true,
            message: '请选择代付渠道',
            trigger: ['blur', 'change'],
          },
        ],
        rate: [{ required: true, message: '请输入代收费率', trigger: 'blur' }],
        fee: [{ required: true, message: '请输入代付费率', trigger: 'blur' }],
        routeStatus: [
          {
            required: true,
            message: '请选择路由状态',
            trigger: ['blur', 'change'],
          },
        ],
      },
      collectionOption: [],
      paymentOption: [],
    }
  },
  methods: {
    handleInput(val, type) {
      val = val.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      val = val.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
      if (val.indexOf('.') < 0 && val != '') {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        val = parseFloat(val)
      }
      this.form2[type] = val
      this.$forceUpdate()
    },
    init() {
      if (this.action == 'edit') {
        this.form2 = Object.assign({}, this.value)
      }
      this.$axios
        .get('/routeChannelInfo/selectByCondition', { params: {} })
        .then(res => {
          res.data.map(item => {
            if (item.productId == '110') {
              this.collectionOption.push({
                channelName: item.channelName,
                channelId: item.channelId,
              })
            }
            if (item.productId == '120') {
              this.paymentOption.push({
                channelName: item.channelName,
                channelId: item.channelId,
              })
            }
          })
        })
    },
    closeDialog() {
      this.form2 = {
        productId: '',
        agtId: '',
        channelId: '',
        routeStatus: '01',
        deductionType: '',
        productPrice: '',
        routeWeight: '',
        timeStart: '',
        timeEnd: '',
        appId: '',
        rate: '5',
        fee: '5',
        withdrawChannelId: '',
        editPageVer: 'v2',
      }
      this.$refs['form2'].resetFields() //关闭的时候重置表单
      this.$emit('update:show', false)
      this.collectionOption = []
      this.paymentOption = []
    },
    getOptions() {
      this.$axios
        .get('/merchant/selectListForOption', { params: {hasAgent:1} })
        .then(res => {
          this.merchantList = res.data
        })
    },
    saveSystem() {
      this.$refs['form2'].validate(valid => {
        if (valid) {
          let url = '/routeConfigInfo/routeConfigInfoUpdate'
          if (this.action === 'add') {
            url = '/routeConfigInfo/routeConfigInfoAdd'
          }

          let params = {
            routeId: this.form2.routeId,
            appId: this.form2.appId,
            routeStatus: this.form2.routeStatus,
            channelId: this.form2.channelId,
            withdrawChannelId: this.form2.withdrawChannelId,
            editPageVer: 'v2',
          }

          this.axios.post(url, params).then(res => {
            if (res.code === 200) {
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'success',
              })
              // this.$bus.$emit('refresh') //通知刷新

              this.closeDialog()
            } else {
              this.$notify.error({
                title: '提示',
                message: res.msg,
              })
            }
          })
        } else {
          return false
        }
      })
    },
  },
  created() {
    this.getOptions()
  },
  mounted() {
    this.$bus.$on('refreshButton', isButton => {
      this.isButton = isButton
    }),
      this.$bus.$on('isDisabled', isDisabled => {
        this.isDisabled = isDisabled
      }),
      this.$bus.$on('dialogShow', dialogShow => {
        this.dialogShow = dialogShow
      })
  },
}
</script>

<style scoped>
</style>